import { valueMatcher } from './data-helpers';

export type IValueFieldAccessor = (item: any) => string;

export function isDisabled(props: { disabled?: boolean }) {
  return props.disabled === true;
}

export function isReadOnly(props: { readOnly?: boolean }) {
  return props.readOnly === true;
}

export function contains(item: any, values?: any[], valueField?: string | IValueFieldAccessor) {
  return Array.isArray(values)
    ? values.some((value) => valueMatcher(item, value, valueField))
    : valueMatcher(item, values, valueField);
}

export function isDisabledItem(
  item: any,
  props: { disabledItems?: any[]; valueField?: string | IValueFieldAccessor }
) {
  // TODO: fix any
  return isDisabled(props as any) || contains(item, props.disabledItems, props.valueField);
}

export function isReadOnlyItem(
  item: any,
  props: { readOnlyItems?: any[]; valueField?: string | IValueFieldAccessor }
) {
  // TODO: fix any
  return isReadOnly(props as any) || contains(item, props.readOnlyItems, props.valueField);
}
